<script>
  import { getContext } from "svelte";

  const { padding, width, height, xScale } = getContext("LayerCake");

  /** @type {any | undefined} The x-value (in LayerCake coordinates) of the current mouse position. Use with `bind:` */
  export let x = undefined;

  const getPx = (event) => event.offsetX - $padding.left;

  function handleMouseMove(event) {
    let px = getPx(event);
    px = Math.min(Math.max(px, 0), $width);
    x = $xScale.invert(px);
  }

  function handleMouseLeave() {
    x = undefined;
  }
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<g on:mousemove={handleMouseMove} on:mouseleave={handleMouseLeave}>
  <rect width={$width} height={$height} fill="transparent" />
  <slot />
</g>
